/* P.O.M 3D MASTER — Rail-Perspektive (Highlights) */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function bindRail(rail) {
    if (rail.hasAttribute('data-pom-rail-bound')) return;
    rail.setAttribute('data-pom-rail-bound', '');

    var items = Array.prototype.slice.call(rail.querySelectorAll('.pom-rail__item'));
    if (!items.length) return;

    var ticking = false;
    var MAX_ROT = 8;
    var MIN_SCALE = 0.85;

    function update() {
      ticking = false;
      if (reduced.matches) return;
      var r = rail.getBoundingClientRect();
      var center = r.left + r.width / 2;
      var reach = r.width / 2 || 1;

      for (var i = 0; i < items.length; i++) {
        var el = items[i];
        var b = el.getBoundingClientRect();
        var d = (b.left + b.width / 2 - center) / reach;
        if (d > 1) d = 1;
        if (d < -1) d = -1;
        el.style.setProperty('--pom-r', (-d * MAX_ROT).toFixed(2) + 'deg');
        el.style.setProperty('--pom-s', (1 - Math.abs(d) * (1 - MIN_SCALE)).toFixed(3));
      }
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    rail.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  }

  function boot() {
    document.querySelectorAll('.pom-rail').forEach(bindRail);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
